
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","viewBox":"0 0 48 42"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.5 42C2.1 42 0 39.9 0 37.5v-24C0 11.1 2.1 9 4.5 9H12V4.5C12 2.1 14.1 0 16.5 0h15C33.9 0 36 2.1 36 4.5V9h7.5c2.4 0 4.5 2.1 4.5 4.5v24c0 2.4-2.1 4.5-4.5 4.5h-39zM30 9H18V6h12v3zm-7.693 6.397c.21-.215.524-.397.893-.397h1.6c.368 0 .683.182.892.397.21.215.388.538.388.915v2.572h-4.16v-2.572c0-.377.177-.7.387-.915zm-.387 5.784c-.327.211-.702.51-1.034.883-.458.517-.886 1.242-.886 2.123v9.844c0 .542.258 1.028.587 1.367.33.338.805.602 1.333.602h4.16c.528 0 1.003-.264 1.333-.602.33-.339.587-.825.587-1.367v-9.843c0-.882-.428-1.607-.886-2.124a5.11 5.11 0 00-1.034-.883v-.931h-4.16v.931zM34.2 15c-.369 0-.683.182-.893.397a1.33 1.33 0 00-.387.915v2.572h4.16v-2.572c0-.377-.178-.7-.387-.915A1.266 1.266 0 0035.8 15h-1.6zm-2.314 7.064a5.111 5.111 0 011.034-.883v-.931h4.16v.931c.327.211.703.51 1.034.883.458.517.886 1.242.886 2.123v9.844c0 .542-.258 1.028-.587 1.367-.33.338-.805.602-1.333.602h-4.16c-.528 0-1.003-.264-1.333-.602-.33-.339-.587-.825-.587-1.367v-9.843c0-.882.428-1.607.886-2.124zm-20.579-6.667c.21-.215.524-.397.893-.397h1.6c.368 0 .683.182.893.397.21.215.387.538.387.915v2.572h-4.16v-2.572c0-.377.177-.7.387-.915zm-.387 5.784a5.11 5.11 0 00-1.034.883C9.428 22.581 9 23.306 9 24.187v9.844c0 .542.258 1.028.587 1.367.33.338.805.602 1.333.602h4.16c.528 0 1.003-.264 1.333-.602.33-.339.587-.825.587-1.367v-9.843c0-.882-.428-1.607-.886-2.124a5.11 5.11 0 00-1.034-.883v-.931h-4.16v.931z","fill":"currentColor"}})])
          )
        }
      }
    